import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import apiKeys from "@/store/apiKeys";
import app from "@/store/app";
import settings from "@/store/settings";
import queues from "@/store/queues";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userData: {},
    allProjects: [],
    projectsLoaded: false,
  },
  mutations: {
    setUserData(state, payload) {
      state.userData = payload;
      localStorage.setItem("name", payload.name);
      localStorage.setItem("idUser", payload.idUser);
      localStorage.setItem("rol", payload.rol);
      localStorage.setItem("refreshToken", payload.refreshToken);
      localStorage.setItem("accessToken", payload.accessToken);
    },
    setProjects(state, data) {
      state.allProjects = data;
      if (localStorage.getItem("projectId") == null) {
        localStorage.setItem("projectId", data[0].id);
        localStorage.setItem("projectName", data[0].name);
      }
      state.projectsLoaded = true
    }
  },
  actions: {

    loginUser({ commit, dispatch }) {
      axios
        .get("/api")
        .then(response => {
          if (response.data.user) {
            commit("setUserData", response.data.user);

            axios.get("/projects").then(response => {
              let result = response.data;

              if (result.length == 0) {
                // console.log("NO hay proyectos")
                // console.log(response)
                dispatch("getProjectsRepeatAxios")
              }
                commit("setProjects", result);
            }).catch(errors => {
              // console.log("Cannot log in");
            });
            commit("setProjects", result);
          } else {
            location.replace(response.data);
          }
        })
        .catch(errors => {
          // console.log("Cannot log in x");
        });
    },

    async getProjectsRepeatAxios({ commit, dispatch }) {
      let myProjects = await dispatch("getAllProjects")
      let tries = 0
      if (myProjects.length == 0 || myProjects == false) {
        while (tries < 5) {
          // console.log(tries)
          // console.log(myProjects.length)
          myProjects = await dispatch("getAllProjects")
          tries++;
        }
      } else {
        commit("setProjects", myProjects);
      }
      return true
    },

    async getAllProjects({ commit, dispatch }) {
      try {
        let response = await axios.get(`/projects`);
        let result = response.data;
        return result;
      } catch (err) {
        console.log(err);
        return false
        // commit("changeAlertModal", err.response.data.result[0]);
      }
    },


    logout({ commit }) {
      axios
        .get("/api/logout")
        .then(response => {
          commit("setUserData", "");
          localStorage.removeItem("name");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("accessToken");
          location.replace(response.data);
        })
        .catch(errors => {
          console.log("Cannot log out");
        });
    }
  },
  modules: { apiKeys, app, settings, queues }
});



// WEBPACK FOOTER //
// ./src/store/index.js